/**
 * Test array includes
 * @param {Array} from
 * @param {Array} target
 */
export const includes = (from, target) => from.every((value) => target.indexOf(value) >= -1);
/**
 * Compare array equality
 * @param {Array} from
 * @param {Array} target
 */
export const equals = (from, target) => from.length === target.length && includes(from, target) && includes(target, from);
//# sourceMappingURL=helpers.js.map